import type { TLostDealsSortField } from '@crm/entities/deal';

export const DEALS_TABLE_LIMIT_OPTIONS = {
    headerHeight: 40,
    maxLimit: 100,
    rowGap: 4,
    rowHeight: 40,
};

export const DEALS_TABLE_SORT_FIELDS = {
    lostAt: 'lost_at',
} as const satisfies Record<string, TLostDealsSortField>;

export const DEALS_TABLE_ALLOW_SORT_CLEAR = Object.keys(DEALS_TABLE_SORT_FIELDS).length > 1;
